import axios from 'axios';
import { embedDashboard } from "@superset-ui/embedded-sdk";
import {Box, Button, Dialog, DialogContent, Typography} from "@mui/material";
import React, { useEffect } from "react";

interface DashDatiProgettoProps {
  codprogprop: string;
  desprogprop: string;
  onClose: () => void;
}

// const supersetUrl = 'http://172.16.0.89:8088';
// const supersetApiUrl = supersetUrl + '/api/v1/security';
const dashboardId = "aebfd694-47dd-4f71-9da4-c02f25e3b8a8";

const DashDatiProgetto: React.FC<DashDatiProgettoProps> = ({ codprogprop, desprogprop, onClose }) => {
  useEffect(() => {
    async function getToken() {
      try {
        const login_body = {
          password: "Super2025@",
          provider: "db",
          refresh: true,
          username: "admin"
        };

        const login_headers = {
          headers: { "Content-Type": "application/json" }
        };

        const { data } = await axios.post(`${BASE_API_URL_SUPERSET}/login`, login_body, login_headers);
        const access_token = data['access_token'];

        const guest_token_body = {
          resources: [{ type: "dashboard", id: dashboardId }],
          rls: [{ clause: `CODPROG = '${codprogprop}'` }],
          user: { username: "", first_name: "", last_name: "" }
        };

        const guest_token_headers = {
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${access_token}`
          }
        };

        const guestTokenResponse = await axios.post(`${BASE_API_URL_SUPERSET}/guest_token/`, guest_token_body, guest_token_headers);
        const guestToken = guestTokenResponse.data['token'];

        const mountPoint = document.getElementById("superset-container");
        if (mountPoint) {
          embedDashboard({
            id: dashboardId,
            supersetDomain: BASE_URL_SUPERSET,
            mountPoint: mountPoint,
            fetchGuestToken: () => guestToken,
            dashboardUiConfig: {
              hideTitle: true,
              filters: { expanded: false },
              urlParams: { standalone: true }
            },
          });
        } else {
          console.error("Mount point not found.");
        }

        // Ensure iframe fits its container
        setTimeout(() => {
          const iframe = document.querySelector("#superset-container iframe") as HTMLIFrameElement;
          if (iframe) {
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            iframe.style.border = 'none';
          }
        }, 1000);
      } catch (error) {
        console.error("Error embedding Superset dashboard:", error);
      }
    }

    getToken();
  }, [codprogprop]);

  return (
    <Dialog onClose={onClose} open fullWidth maxWidth="xl">
      <Box display="flex" flexDirection="column" height="150vh">
        {/* Close button */}
   <Box display="flex" justifyContent="space-between" alignItems="center" p={1}>
      <Typography variant="h6" fontWeight="bold" color="primary">
        {desprogprop}
      </Typography>
      <Button variant="contained" onClick={onClose} color="error" size="small">
        CHIUDI
      </Button>
    </Box>

        {/* Dashboard embed */}
        <DialogContent style={{ flex: 1, padding: 0 }}>
          <div id="superset-container" style={{ width: "100%", height: "95%" }}></div>
        </DialogContent>
      </Box>
    </Dialog>
  );
};

export default DashDatiProgetto;
